@if (exhibitor?.description || tags.length > 0) {
<section class="exhibitordescription">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-exhibitorDescription">
          {{ exhibitor?.name }}
          @if (fair) { auf der {{ fair.name }}
          }
        </h2>
        @if (exhibitor?.description) {
        <planone-expandable-text
          [text]="exhibitor?.description | TransformLinefeed | WYSIWYGTagFilter"></planone-expandable-text>
        }
      </div>
    </div>
  </div>
</section>
} @if (tags) {
<section class="exhibitortags">
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <planone-expandable-chip-list
          [fairId]="exhibitor?.fair_id"
          [chips]="tags"
          [threshold]="8"
          [chipsListClickable]="chipsListClickable"></planone-expandable-chip-list>
      </div>
    </div>
  </div>
</section>
}
